/* CONTACTS FAMILY - Homepage V5 interactions (hero carousel, featured carousel, reviews, reveal) */
(() => {
  const menus = document.querySelectorAll('[data-cf5-mobile-menu]');
  menus.forEach((menu) => {
    const toggle = document.querySelector('[data-cf5-menu-toggle][aria-controls="' + menu.id + '"]');
    if (!toggle) return;
    const closeButtons = menu.querySelectorAll('[data-cf5-menu-close]');
    let lastFocused = null;

    const setOpen = (open) => {
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.documentElement.classList.toggle('cf5-menu-open', open);
      if (open) {
        lastFocused = document.activeElement;
        const firstLink = menu.querySelector('a');
        if (firstLink) firstLink.focus();
      } else if (lastFocused instanceof HTMLElement) {
        lastFocused.focus();
      }
    };

    toggle.addEventListener('click', () => setOpen(menu.hidden));
    closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) setOpen(false);
    });
  });
})();

(() => {
  const slides = Array.from(document.querySelectorAll('[data-hero-slide]'));
  const tabs = Array.from(document.querySelectorAll('[data-hero-tab]'));
  if (!slides.length) return;
  let currentSlide = 0;
  let isTransitioning = false;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const carousel = document.querySelector('.hero-carousel');
  const autoplayEnabled = carousel && carousel.dataset.autoplay !== 'false' && slides.length > 1;
  const autoplayDelay = Math.max(2, Number(carousel?.dataset.autoplayInterval) || 5) * 1000;
  const warmedImages = new WeakSet();
  const prepareSlide = (index) => {
    const image = slides[(index + slides.length) % slides.length].querySelector('img');
    if (!image) return null;
    image.loading = 'eager';
    if (image.decode && !warmedImages.has(image)) {
      warmedImages.add(image);
      image.decode().catch(() => warmedImages.delete(image));
    }
    return image;
  };
  prepareSlide(currentSlide);
  prepareSlide(currentSlide + 1);
  let autoplayTimer;
  let hovering = false;
  let touching = false;
  let focused = false;
  let visible = true;
  let disposed = false;
  const stopAutoplay = () => window.clearTimeout(autoplayTimer);
  const scheduleAutoplay = () => {
    stopAutoplay();
    if (!autoplayEnabled || disposed || hovering || touching || focused || !visible || document.hidden || prefersReducedMotion.matches) return;
    autoplayTimer = window.setTimeout(() => {
      showSlide(currentSlide + 1, 1);
    }, autoplayDelay);
  };
  const updateTabs = () => {
    tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === currentSlide)));
  };
  const showSlide = (index, direction = 1) => {
    scheduleAutoplay();
    const nextSlide = (index + slides.length) % slides.length;
    if (isTransitioning || nextSlide === currentSlide) return;

    const current = slides[currentSlide];
    const next = slides[nextSlide];
    const from = direction < 0 ? 'from-left' : 'from-right';
    const to = direction < 0 ? 'to-right' : 'to-left';

    if (prefersReducedMotion.matches) {
      current.hidden = true;
      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      next.hidden = false;
      next.classList.add('is-active');
      next.setAttribute('aria-hidden', 'false');
      currentSlide = nextSlide;
      updateTabs();
      prepareSlide(currentSlide + 1);
      return;
    }

    isTransitioning = true;
    const beginTransition = () => {
      if (disposed) return;
      scheduleAutoplay();
      next.hidden = false;
      next.setAttribute('aria-hidden', 'false');
      current.setAttribute('aria-hidden', 'true');
      next.classList.add('is-entering', from);
      let fallbackTimer;
      let finished = false;
      const finish = () => {
        if (finished) return;
        finished = true;
        window.clearTimeout(fallbackTimer);
        next.removeEventListener('transitionend', onTransitionEnd);
        current.hidden = true;
        current.classList.remove('is-active', 'is-leaving', 'to-left', 'to-right');
        next.classList.remove('is-entering', 'from-left', 'from-right');
        currentSlide = nextSlide;
        updateTabs();
        isTransitioning = false;
        prepareSlide(currentSlide + 1);
      };
      const onTransitionEnd = (event) => {
        // Ignore short/cancelled reversals: only the full crossfade may finalize.
        if (event.target === next && event.propertyName === 'opacity' && event.elapsedTime >= 0.65) finish();
      };
      next.addEventListener('transitionend', onTransitionEnd);
      // Two paint frames establish the entry state without a synchronous layout read.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (disposed) return;
        next.classList.add('is-active');
        current.classList.add('is-leaving', to);
        fallbackTimer = window.setTimeout(finish, 780);
      }));
    };
    const image = prepareSlide(nextSlide);
    if (image && !image.complete && image.decode) {
      image.decode().catch(() => {}).then(beginTransition);
    } else {
      beginTransition();
    }
  };
  tabs.forEach((tab) => tab.addEventListener('click', () => {
    const index = Number(tab.dataset.heroTab);
    showSlide(index, index < currentSlide ? -1 : 1);
  }));
  const prev = document.querySelector('[data-hero-prev]');
  const next = document.querySelector('[data-hero-next]');
  if (prev) prev.addEventListener('click', () => showSlide(currentSlide - 1, -1));
  if (next) next.addEventListener('click', () => showSlide(currentSlide + 1, 1));
  const viewport = document.querySelector('.hero__viewport');
  if (carousel) {
    carousel.addEventListener('mouseenter', () => { hovering = true; stopAutoplay(); });
    carousel.addEventListener('mouseleave', () => { hovering = false; scheduleAutoplay(); });
    carousel.addEventListener('focusin', () => { focused = true; stopAutoplay(); });
    carousel.addEventListener('focusout', (event) => { focused = carousel.contains(event.relatedTarget); scheduleAutoplay(); });
    carousel.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') { touching = true; stopAutoplay(); }
    });
    const release = () => { touching = false; scheduleAutoplay(); };
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);
    document.addEventListener('visibilitychange', scheduleAutoplay);
    prefersReducedMotion.addEventListener('change', scheduleAutoplay);
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      scheduleAutoplay();
    }, { threshold: 0.1 });
    observer.observe(carousel);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(carousel)) { disposed = true; stopAutoplay(); observer.disconnect(); }
    });
    window.addEventListener('pagehide', stopAutoplay);
    window.addEventListener('pageshow', scheduleAutoplay);
    scheduleAutoplay();
  }
  if (viewport) {
    let start = null;
    let suppressClick = false;
    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      start = { x: event.clientX, y: event.clientY };
    });
    viewport.addEventListener('pointerup', (event) => {
      if (!start || event.pointerType === 'mouse') return;
      const deltaX = event.clientX - start.x;
      const deltaY = event.clientY - start.y;
      start = null;
      if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
      suppressClick = true;
      showSlide(currentSlide + (deltaX < 0 ? 1 : -1), deltaX < 0 ? 1 : -1);
      window.setTimeout(() => { suppressClick = false; }, 350);
    });
    viewport.addEventListener('pointercancel', () => { start = null; });
    viewport.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
  }
})();

(() => {
  const track = document.querySelector('[data-featured-track]');
  if (!track) return;
  const prevBtn = document.querySelector('[data-featured-prev]');
  const nextBtn = document.querySelector('[data-featured-next]');
  const dotsContainer = document.querySelector('[data-featured-dots]');
  const total = track.children.length;
  const getVisibleCount = () => {
    const w = window.innerWidth;
    if (w <= 749) return 2;
    if (w <= 989) return 2;
    return 3;
  };
  let index = 0;
  const maxIndex = () => Math.max(0, total - getVisibleCount());
  function updateDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';
    for (let i = 0; i <= maxIndex(); i++) {
      const btn = document.createElement('button');
      btn.className = 'featured-pieces__dot';
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Go to product group ' + (i + 1));
      btn.setAttribute('aria-current', i === index ? 'true' : 'false');
      btn.addEventListener('click', () => { index = i; render(); });
      dotsContainer.appendChild(btn);
    }
  }
  function render() {
    const visible = getVisibleCount();
    const gap = window.innerWidth <= 749 ? 14 : 18;
    const cardWidth = (track.clientWidth - gap * (visible - 1)) / visible;
    const shift = index * (cardWidth + gap);
    track.style.transform = 'translateX(-' + shift + 'px)';
    if (prevBtn) prevBtn.disabled = index <= 0;
    if (nextBtn) nextBtn.disabled = index >= maxIndex();
    const dots = dotsContainer ? dotsContainer.querySelectorAll('button') : [];
    dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
  }
  if (prevBtn) prevBtn.addEventListener('click', () => { if (index > 0) { index--; render(); } });
  if (nextBtn) nextBtn.addEventListener('click', () => { if (index < maxIndex()) { index++; render(); } });
  const viewport = track.closest('.featured-pieces__viewport');
  if (viewport) {
    let start = null;
    let suppressClick = false;
    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      start = { x: event.clientX, y: event.clientY };
    });
    viewport.addEventListener('pointerup', (event) => {
      if (!start || event.pointerType === 'mouse') return;
      const deltaX = event.clientX - start.x;
      const deltaY = event.clientY - start.y;
      start = null;
      if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
      const nextIndex = Math.max(0, Math.min(maxIndex(), index + (deltaX < 0 ? 1 : -1)));
      if (nextIndex === index) return;
      index = nextIndex;
      suppressClick = true;
      render();
      window.setTimeout(() => { suppressClick = false; }, 350);
    });
    viewport.addEventListener('pointercancel', () => { start = null; });
    viewport.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
  }
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      index = Math.min(index, maxIndex());
      updateDots();
      render();
    }, 120);
  });
  updateDots();
  render();
})();

(() => {
  const viewport = document.querySelector('[data-reviews-viewport]');
  if (!viewport) return;
  const track = viewport.querySelector('[data-reviews-track]');
  if (!track) return;
  track.innerHTML += track.innerHTML;
  let down = false, startX = 0, pos = 0;
  viewport.addEventListener('mouseenter', () => { track.style.animationPlayState = 'paused'; });
  viewport.addEventListener('mouseleave', () => { if (!down) track.style.animationPlayState = 'running'; });
  viewport.addEventListener('mousedown', (e) => { down = true; startX = e.pageX - pos; viewport.classList.add('is-dragging'); });
  window.addEventListener('mousemove', (e) => { if (!down) return; pos = e.pageX - startX; track.style.transform = 'translateX(' + pos + 'px)'; });
  window.addEventListener('mouseup', () => { down = false; track.style.transform = ''; track.style.animationPlayState = 'running'; viewport.classList.remove('is-dragging'); });
})();

(() => {
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
  }), { threshold: 0.12 });
  document.querySelectorAll('.brand-trust .reveal').forEach((el) => io.observe(el));
})();
